import * as XLSX from 'xlsx';

export const PRIVATE_MESSAGE_HEADERS = [
    '报名ID(勿改)',
    '姓名(勿改)',
    '身份证号(勿改)',
    '手机号(勿改)',
    '报考专业(勿改)',
    '考试批次(勿改)',
    '公告内容',
];

const INSTRUCTION_ROWS = [
    ['个性化私信导入模板 - 填写说明'],
    [''],
    ['1. 请勿修改前六列（报名ID、姓名、身份证号、手机号、报考专业、考试批次），系统据此匹配考生。'],
    ['2. 在「公告内容」列填写要发送给该考生的通知正文，不同考生可填写不同内容。'],
    ['3. 模板仅包含当前批次下「已提交报名且审批通过」的考生。'],
    ['4. 导入后将弹出确认窗口，确认后向对应考生发送定向站内信。'],
    [''],
    ['请在「私信名单」工作表中填写数据。'],
];

function cellText(value) {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value).trim();
}

function formatExportFileTime() {
    const d = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
}

function buildWorkbook(dataRows, instructionRows) {
    const instructionSheet = XLSX.utils.aoa_to_sheet(instructionRows);
    const dataSheet = XLSX.utils.aoa_to_sheet([
        PRIVATE_MESSAGE_HEADERS,
        ...dataRows,
    ]);

    instructionSheet['!cols'] = [{ wch: 88 }];
    dataSheet['!cols'] = [
        { wch: 12 }, { wch: 10 }, { wch: 20 }, { wch: 14 }, { wch: 24 }, { wch: 14 }, { wch: 40 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, instructionSheet, '填写说明');
    XLSX.utils.book_append_sheet(wb, dataSheet, '私信名单');
    return wb;
}

export function downloadPrivateMessageTemplate(candidates, entranceName) {
    const list = Array.isArray(candidates) ? candidates : [];
    const batchName = entranceName || '';
    const dataRows = list.map((item) => ([
        item.applicationId,
        item.applicantName || '',
        item.idCardNumber || '',
        item.phone || '',
        item.positionName || '',
        batchName,
        '',
    ]));
    const wb = buildWorkbook(dataRows, INSTRUCTION_ROWS);
    const safeName = batchName.replace(/[\\/:*?"<>|]/g, '_') || '批次';
    XLSX.writeFile(wb, `个性化私信模板-${safeName}-${formatExportFileTime()}.xlsx`);
}

function findDataSheet(workbook) {
    if (workbook.SheetNames.indexOf('私信名单') !== -1) {
        return workbook.Sheets['私信名单'];
    }
    return workbook.Sheets[workbook.SheetNames[0]];
}

function rowToObject(row) {
    const obj = {};
    PRIVATE_MESSAGE_HEADERS.forEach((header, index) => {
        obj[header] = row[index];
    });
    return obj;
}

function isHeaderRow(row) {
    if (!row || !row.length) {
        return false;
    }
    const first = cellText(row[0]);
    return first.indexOf('报名ID') !== -1 || first === '报名ID(勿改)';
}

function isEmptyDataRow(row) {
    if (!row || !row.length) {
        return true;
    }
    return PRIVATE_MESSAGE_HEADERS.every((_header, index) => cellText(row[index]) === '');
}

export function parsePrivateMessageWorkbook(workbook) {
    const sheet = findDataSheet(workbook);
    const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' });
    const previewList = [];
    const errors = [];

    rows.forEach((row, rowIndex) => {
        if (isHeaderRow(row) || isEmptyDataRow(row)) {
            return;
        }
        const item = rowToObject(row);
        const applicationIdText = cellText(item['报名ID(勿改)']);
        const content = cellText(item['公告内容']);
        if (!applicationIdText) {
            errors.push(`第 ${rowIndex + 1} 行：报名ID不能为空`);
            return;
        }
        if (!content) {
            errors.push(`第 ${rowIndex + 1} 行：公告内容不能为空`);
            return;
        }
        previewList.push({
            rowIndex: rowIndex + 1,
            applicationId: Number(applicationIdText),
            applicantName: cellText(item['姓名(勿改)']),
            idCardNumber: cellText(item['身份证号(勿改)']),
            phone: cellText(item['手机号(勿改)']),
            positionName: cellText(item['报考专业(勿改)']),
            entranceName: cellText(item['考试批次(勿改)']),
            content,
        });
    });

    if (!previewList.length && !errors.length) {
        errors.push('未读取到有效数据，请使用系统下载的模板填写');
    }

    const seenIds = new Set();
    previewList.forEach((item) => {
        if (seenIds.has(item.applicationId)) {
            errors.push(`报名ID=${item.applicationId}：重复出现`);
        }
        seenIds.add(item.applicationId);
    });

    return {
        previewList,
        errors: Array.from(new Set(errors)),
        payload: previewList.map((item) => ({
            applicationId: item.applicationId,
            applicantName: item.applicantName,
            idCardNumber: item.idCardNumber,
            content: item.content,
        })),
    };
}

export function readPrivateMessageFile(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
            try {
                const data = new Uint8Array(event.target.result);
                const workbook = XLSX.read(data, { type: 'array', cellDates: true });
                resolve(workbook);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = () => reject(new Error('文件读取失败'));
        reader.readAsArrayBuffer(file);
    });
}
